import React from "react";
import styles from './Paper.module.sass';

const Paper = ({ children, ...props }: Props) => {
    return <div className={styles['paper']} {...props}>
        { children }
    </div>;
}

interface Props extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {

}

export default Paper;